import gql from "graphql-tag";

const VELOCITY_REPORTPDF_QUERY = gql`
  query VelocityReportPDF(
    $assetsSelected: [Int]!
    $fechaInicio: Datetime
    $fechaFin: Datetime
    $driversSelected: [Int]
    $velocidadDesde: Float
    $velocidadHasta: Float
    $days: [WeekDaysEnum]
  ) {
    velocityReportPDF(
      assetsSelected: $assetsSelected
      fechaInicio: $fechaInicio
      fechaFin: $fechaFin
      driversSelected: $driversSelected
      velocidadDesde: $velocidadDesde
      velocidadHasta: $velocidadHasta
      days: $days
    )
  }
`;

export default VELOCITY_REPORTPDF_QUERY;
